import { SupplierResponseDto } from "../shared/dtos/supplier/SupplierResponseDto";
import { SupplierSummaryDto } from "../shared/dtos/supplier/SupplierSummaryDto";

export class SupplierMapper {
  public static mapToSummary(
    supplier: SupplierResponseDto,
  ): SupplierSummaryDto {
    return {
      id: supplier.id,
      name: supplier.name,
      contactPerson: supplier.contactPerson,
      phoneNumber: supplier.phoneNumber,
      email: supplier.email,
      productCategory: supplier.productCategory,
      website: supplier.website,
      taxId: supplier.taxId,
    };
  }
}
